/**
 * Imperial Privacy Systems — collection-cart.js
 * Carrier collection: tier toggle, AJAX add-to-cart, cart drawer open/render.
 * Loaded on collection.carriers template only.
 */
(function () {
  'use strict';

  // ─── TIER TOGGLE ────────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var tierBtn = e.target.closest('[data-tier]');
    if (!tierBtn) return;
    var card = tierBtn.closest('.carrier-card');
    if (!card) return;

    // Update active state
    card.querySelectorAll('[data-tier]').forEach(function (b) {
      b.classList.toggle('active', b === tierBtn);
    });

    // Update displayed price and variant id
    var price    = tierBtn.dataset.price;
    var variantId = tierBtn.dataset.variantId;
    var priceEl  = card.querySelector('[data-carrier-price]');
    var varEl    = card.querySelector('[data-add-to-cart]');

    if (priceEl && price)     priceEl.textContent = price;
    if (varEl && variantId)   varEl.dataset.variantId = variantId;
  });

  // ─── AJAX ADD TO CART ───────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var card     = btn.closest('.carrier-card');
    var qtyInput = card && card.querySelector('.qty-input');
    var qty      = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = 'Add to cart <span class="arr" aria-hidden="true"></span>';
        }, 1200);
        CartDrawer.open();
        CartDrawer.refresh();
      })
      .catch(function (err) {
        console.error(err);
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  });

  // ─── QTY STEPPERS (carrier cards) ──────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-dec, .qty-inc');
    if (!btn) return;
    var wrap  = btn.closest('.qty-wrap');
    var input = wrap && wrap.querySelector('.qty-input');
    if (!input) return;
    var current = parseInt(input.value) || 1;
    input.value = btn.classList.contains('qty-dec')
      ? Math.max(1, current - 1)
      : current + 1;
  });

  // ─── CART DRAWER ────────────────────────────────────────────────────────────

  var CartDrawer = {
    drawer:   null,
    overlay:  null,
    body:     null,
    countEls: [],

    init: function () {
      this.drawer  = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-overlay');
      this.body    = document.getElementById('cart-drawer-body');
      this.countEls = Array.from(document.querySelectorAll('[data-cart-count]'));

      if (!this.drawer) return;

      // Close button
      var closeBtn = document.getElementById('cart-close');
      if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));

      // Overlay click
      if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') CartDrawer.close();
      });

      // Cart icon opens drawer
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-open-cart]')) {
          e.preventDefault();
          CartDrawer.open();
          CartDrawer.refresh();
        }
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'false');
      this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('visible');
      document.body.style.overflow = '';
    },

    refresh: function () {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          CartDrawer.render(cart);
          CartDrawer.updateCount(cart.item_count);
        })
        .catch(function (err) { console.error('Cart refresh failed', err); });
    },

    updateCount: function (count) {
      this.countEls.forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },

    render: function (cart) {
      if (!this.body) return;
      if (!cart.items || cart.items.length === 0) {
        this.body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }

      var fmt = function (cents) {
        return '$' + (cents / 100).toFixed(2);
      };

      var html = '<div class="cart-items">';
      cart.items.forEach(function (item) {
        html += '<div class="cart-item" data-key="' + item.key + '">'
          + '<div class="cart-item-img">'
          +   (item.image ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">' : '')
          + '</div>'
          + '<div class="cart-item-info">'
          +   '<div class="cart-item-title">' + item.product_title + '</div>'
          +   (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '')
          +   '<div class="cart-item-row">'
          +     '<div class="qty-wrap qty-wrap--sm">'
          +       '<button class="qty-btn qty-dec" data-cart-key="' + item.key + '" data-delta="-1" aria-label="Remove one">−</button>'
          +       '<span class="cart-item-qty">' + item.quantity + '</span>'
          +       '<button class="qty-btn qty-inc" data-cart-key="' + item.key + '" data-delta="1"  aria-label="Add one">+</button>'
          +     '</div>'
          +     '<div class="cart-item-price">' + fmt(item.line_price) + '</div>'
          +   '</div>'
          + '</div>'
          + '</div>';
      });
      html += '</div>';

      html += '<div class="cart-footer">'
        + '<div class="cart-subtotal">'
        +   '<span>Subtotal</span>'
        +   '<span>' + fmt(cart.total_price) + '</span>'
        + '</div>'
        + '<a href="/checkout" class="btn primary" style="width:100%;justify-content:center;padding:16px">'
        +   'Checkout <span class="arr" aria-hidden="true"></span>'
        + '</a>'
        + '<a href="/cart" style="display:block;text-align:center;font-family:var(--mono);font-size:11px;letter-spacing:.08em;color:var(--muted);margin-top:8px">View full cart</a>'
        + '</div>';

      this.body.innerHTML = html;
    }
  };

  // ─── CART ITEM QTY CHANGE (inside drawer) ────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-key][data-delta]');
    if (!btn) return;
    var key     = btn.dataset.cartKey;
    var delta   = parseInt(btn.dataset.delta);
    var qtyEl   = btn.closest('.qty-wrap--sm') && btn.closest('.qty-wrap--sm').querySelector('.cart-item-qty');
    var current = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;
    var newQty  = Math.max(0, current + delta);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CartDrawer.render(cart);
        CartDrawer.updateCount(cart.item_count);
      });
  });

  // ─── INIT ────────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
    CartDrawer.refresh();
  });

  window.CartDrawer = CartDrawer;

})();
